import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllManageAmbassadorInvoice = createAsyncThunk(
  "admin/manage-wallet/get-all-manage-reports",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ManageServiceInvoice.getAllManageAmbassadorInvoice
        }?name=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "manage-ambassador-invoice",
  initialState: {
    all_ambassador_invoice: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AllManageAmbassadorInvoice.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllManageAmbassadorInvoice.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_ambassador_invoice = action.payload || {};
      })
      .addCase(AllManageAmbassadorInvoice.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
